import { queryURLParams } from 'xag-ai-utils';

const params = queryURLParams(location.href);
Object.keys(params).forEach((key) => {
  localStorage.setItem(key, params[key]);
});
